<template>
  <ReportWrapper>
    <template #actions>
      <CfsDropdown
        icon="mdi-tray-arrow-down"
        btn-class="ml-auto"
        medium
        :loading="isLoading"
        color="primary"
        btn-width="32px"
        title="Download"
        offset-x
        :btn-type-text="false"
        :min-width="175"
        nudge-bottom="6px"
        rounded-menu="lg"
        :items="dropdownOptions"
      />
    </template>
  </ReportWrapper>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useReports } from '@/composables/reports/useReports';
import { downloadFileByType } from '@/helpers/download';
import { DocumentTypes, OutputTypes } from '@/constants/reports';
import date from '@/extensions/filters/date';
import DownloadIcon from '@/assets/img/icons/download/download-with-circle.svg';
import ReportWrapper from '@/components/reports/ReportWrapper.vue';

export default defineComponent({
  name: 'OpenInBondAgingReport',
  components: {
    ReportWrapper,
  },
  setup() {
    const { useDownloadInternalInventoryReport } = useReports();
    const { mutateAsync: downloadReport, isLoading } = useDownloadInternalInventoryReport();

    const download = async (outputType: string) => {
      try {
        const { data } = await downloadReport({
          outputType,
          documentType: DocumentTypes.OPEN_IN_BOND_AGING,
        });

        if (!data) return;

        downloadFileByType(data, `Open In Bond Aging ${date(new Date())}`, outputType);
      } catch (e) {
        console.log(e);
      }
    };

    const dropdownOptions = [
      {
        title: 'Download XLSX',
        icon: DownloadIcon,
        iconWidth: 20,
        handler: () => download(OutputTypes.XLSX),
      },
      {
        title: 'Download PDF',
        icon: DownloadIcon,
        iconWidth: 20,
        handler: () => download(OutputTypes.PDF),
      },
      {
        title: 'Download DOCX',
        icon: DownloadIcon,
        iconWidth: 20,
        handler: () => download(OutputTypes.DOCX),
      },
    ];

    return { isLoading, dropdownOptions };
  },
});
</script>
